<template>
    <header class="page-header wow fadeInUp">
        <div class="logo" @click="Home">
            <img :src="logoUrl" alt="">
        </div>
        <div class="tools">
            <!--根据登录状态显示不同内容-->
            <div class="btn login" @click="openLogin" v-if="!isLogin">登录</div>
            <div class="btn register" @click="openReg" v-if="!isLogin">注册</div>
            <el-dropdown @command="handleCommand" v-if="isLogin">
                <div class="user">
                    <!--用户头像：默认使用face.svg头像，当用户上传了照片，那么显示用户上传的照片-->
                    <div class="face">
                        <img :src="(userInfo?.avatar ? (userInfo.avatar.startsWith('/') ? userInfo.avatar : '/' + userInfo.avatar) : require('@/assets/images/face.svg'))" alt="">
                    </div>
                    <!--用户昵称-->
                    <div class="name">{{ userInfo?.nickname || '用户名' }}</div>
                    <i class="el-icon-arrow-down el-icon--right"></i>
                </div>
                <!--用户个人中心、保存的设计作品、退出-->
                <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item command="userCenter">个人中心</el-dropdown-item>
                    <el-dropdown-item command="myDesign">我的设计</el-dropdown-item>
                    <el-dropdown-item command="quit">退出</el-dropdown-item>
                </el-dropdown-menu>
            </el-dropdown>


            <div class="help" @click="showHelp = true">
                <img :src="require('@/assets/images/help.svg')" alt="">
            </div>
        </div>
        <Register v-if="showReg" @close="showReg = false" @openLogin="openLogin" />
        <Login v-if="showLogin" @close="showLogin = false" @openReg="openReg" />
        <helpPop @close="showHelp = false" v-if="showHelp" />
    </header>
</template>
<script>


import BomPop from "@/components/BomPop/index.vue";

var win = window;
import Register from "@/components/Register/index.vue";
import Login from "@/components/Login/index.vue";
import helpPop from "@/components/helpPop/index.vue";
import { mapGetters, mapActions } from 'vuex';
import { getParamApi, getLogoApi } from '@/api.js';
export default {
    computed: {
        ...mapGetters(['isLogin', 'userInfo'])
    },
    components:{
        helpPop, BomPop,
        Register,Login
    },
    data() {
        return {
            showHelp:false,
            showReg:false,
            showLogin:false,
            logoUrl: ''
        }
    },
    mounted() {
        this.checkLoginStatus()
        this.getLogoUrl()
    },
    methods: {
        ...mapActions(['logout', 'getUserInfo']),
        // 获取logo路径
        getLogoUrl() {
            console.log('开始获取logo');
            getLogoApi()
                .then(res => {
                    console.log('获取logo成功:', res);
                    // 使用API返回的contentType来创建Blob
                    const contentType = res.contentType || 'image/png';
                    this.logoUrl = URL.createObjectURL(new Blob([res.data], { type: contentType }));
                    console.log('设置logoUrl为:', this.logoUrl);
                })
                .catch(err => {
                    console.error('获取logo失败:', err);
                    // 使用默认logo作为 fallback
                    this.logoUrl = require('@/assets/images/LOGO.svg');
                })
        },
        Home:function () {
          this.$router.push('/').catch(err => {
            console.log('Navigation prevented:', err)
          })
        },
        openLogin:function () {
            this.showReg = false
            this.showLogin = true
        },
        openReg:function () {
            this.showReg = true
            this.showLogin = false
        },
        handleCommand:function (e) {
            console.log(e)
            if(e === 'userCenter'){
                // 捕获路由导航错误
                this.$router.push('/userCenter').catch(err => {
                    // 忽略导航被阻止的错误
                    console.log('Navigation prevented:', err)
                })
            }
            if(e === 'myDesign'){
                // 捕获路由导航错误
                this.$router.push('/userCenter/works').catch(err => {
                    // 忽略导航被阻止的错误
                    console.log('Navigation prevented:', err)
                })
            }
            if(e === 'quit'){
                this.handleLogout()
            }
        },
        handleLogout() {
            this.logout()
            this.$message.success('退出登录成功')
            this.$router.push('/').catch(err => {
                console.log('Navigation prevented:', err)
            })
        },
        // 检查用户登录状态
        checkLoginStatus() {
            const token = localStorage.getItem('token')
            if (token) {
                this.getUserInfo()
            }
        }
    }
}

</script>
<style scoped lang="scss">

</style>